import * as React from "react";
import {Promise} from "es6-promise";

interface FileUploaderProps {
    label: string,
    onChange: (file: File, base64?: string, files?: File[]) => void,
    accept: string,
    fileSizeMb?: number,
    onSizeExceeded?: (maxFileSize: number) => void,
    multiFiles?: boolean
}

interface FileUploaderState {
    file: File,
    showError: boolean
}

/**
 * Fileuploader.
 */
export class FileUploader extends React.Component<FileUploaderProps, FileUploaderState> {

    private input: HTMLInputElement;

    constructor(props: FileUploaderProps) {
        super(props);

        this.state = {
            file: undefined,
            showError: false
        }
    }

    render() {
        return <div>
            <label className={"btn btn-custom-submit"} style={{color: "white"}}>
                {this.props.label}
                <input type="file" name="file" onChange={this.onChange.bind(this)}
                       accept={this.props.accept} style={{display: "none"}}
                       ref={(ref: HTMLInputElement) => this.input = ref}/>
            </label>
            {!this.props.multiFiles && this.state.file && (
                <p className={"display-inline-block"}>
                    <label className={"file-uploader-file-label"}>
                        {this.state.file.name}
                    </label>
                    <a onClick={this.onDelete.bind(this)}>
                    <span className="av-icon-char clickable" aria-hidden="true" data-av_icon=""
                          data-av_iconfont="entypo-fontello"/></a>
                </p>
            )}
            {this.state.showError && (
                <p className={"file-uploader-error error_message"}>Datei zu groß
                    (maximal: {this.props.fileSizeMb} MB)</p>
            )}
        </div>
    }

    /**
     * on change set file and trigger on change.
     * @param event
     */
    private onChange = (event: React.FormEvent<HTMLInputElement>) => {
        this.setState({showError: false});
        let file = event.currentTarget.files[0];
        if (file.size < parseInt((this.props.fileSizeMb * 1024 * 1024) + '', 10)) {
            this.setState({
                file: file
            });
            this.toBase64(file).then((base64: string) => {
                this.props.onChange(file, base64);
            });
            if (this.props.multiFiles) {
                this.clear();
            }
        } else if (this.props.onSizeExceeded) {
            this.props.onSizeExceeded(this.props.fileSizeMb);
            this.clear();
        } else {
            this.setState({showError: true});
            this.clear();
        }
    };

    /**
     * delete file.
     * @param event
     */
    private onDelete = (event: React.FormEvent<HTMLAnchorElement>) => {
        this.clear();
        this.props.onChange(undefined);
    };

    /**
     * clear file and input.
     */
    private clear() {
        // clear input
        this.input.value = "";
        this.setState({file: undefined});
    }

    /**
     * convert file to base64.
     * @param file
     */
    private toBase64 = (file: File) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
